import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/unselected.png'
import _imports_1 from '@/assets/image/selected.png'
import _imports_2 from '@/assets/image/save.png'
import _imports_3 from '@/assets/image/cancel.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-64b316aa")

_pushScopeId("data-v-64b316aa")
const _hoisted_1 = { class: "building" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "el-icon-plus font-weight700" }, null, -1)
const _hoisted_3 = { class: "margin-left5px font-size15px" }
const _hoisted_4 = { class: "tree-content" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "top",
  src: _imports_0
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "edit-img" }
const _hoisted_10 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")
  const _component_edit_menu = _resolveComponent("edit-menu")
  const _component_set_department_dialog = _resolveComponent("set-department-dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_cus_button, {
      type: "blue",
      style: {"padding":"4px 30px"},
      onClick: _ctx.addBuild
    }, {
      default: _withId(() => [
        _hoisted_2,
        _createVNode("label", _hoisted_3, _toDisplayString(_ctx.ChangeWordList.PeopleDeviceAddTitle), 1)
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode("ul", _hoisted_4, [
      _createVNode(_component_el_scrollbar, {
        ref: "scrollbarRef",
        "view-style": "overflow-x: hidden;"
      }, {
        default: _withId(() => [
          _createVNode("li", {
            class: ['font-weight600 normal', _ctx.activeID == (_ctx.isOffice ? 'all' : 'community') ? 'active' : ''],
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeComBuild(_ctx.isOffice ? 'all' : 'community')))
          }, _toDisplayString(_ctx.ChangeWordList.PeopleDeviceProject), 3),
          _createVNode("li", {
            class: ['normal', _ctx.activeID == 'public' ? 'active' : ''],
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeComBuild('public')))
          }, [
            _hoisted_5,
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(_ctx.$wordList.RDeivicePublicArea), 1)
          ], 2),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.comBuilds, (item) => {
            return (_openBlock(), _createBlock("li", {
              key: item.ID,
              class: [item.Editable ? '' : 'normal', _ctx.activeID == item.ID ? 'active' : ''],
              onClick: ($event: any) => (_ctx.changeComBuild(item.ID)),
              onContextmenu: ($event: any) => (_ctx.editBuild($event, item))
            }, [
              _createVNode("img", {
                class: ['top', item.Editable ? 'top20' : ''],
                src: _imports_0
              }, null, 2),
              _hoisted_7,
              (item.Editable)
                ? (_openBlock(), _createBlock("div", _hoisted_8, [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.tempUnitName,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.tempUnitName = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode("div", _hoisted_9, [
                      _createVNode("img", {
                        src: _imports_2,
                        class: "width35px",
                        onClick: _withModifiers(($event: any) => (_ctx.confirmEdit(item)), ["stop"])
                      }, null, 8, ["onClick"]),
                      _createVNode("img", {
                        src: _imports_3,
                        class: "width35px margin-left10px",
                        onClick: ($event: any) => (_ctx.cancelEdit($event, item))
                      }, null, 8, ["onClick"])
                    ])
                  ]))
                : (_openBlock(), _createBlock("label", _hoisted_10, _toDisplayString(item.UnitName), 1))
            ], 42, ["onClick", "onContextmenu"]))
          }), 128))
        ]),
        _: 1
      }, 512)
    ]),
    (_ctx.showMenu)
      ? (_openBlock(), _createBlock(_component_edit_menu, {
          key: 0,
          position: _ctx.menuPosition,
          onRename: _ctx.renameBuild,
          onDelete: _ctx.deleteBuild
        }, null, 8, ["position", "onRename", "onDelete"]))
      : _createCommentVNode("", true),
    (_ctx.isShowSetDepartmentDialog)
      ? (_openBlock(), _createBlock(_component_set_department_dialog, {
          key: 1,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowSetDepartmentDialog=false)),
          onSuccess: _ctx.refreshBuilds,
          initForm: _ctx.setDepartmentForm,
          operate: _ctx.setDepartmentOperate
        }, null, 8, ["onSuccess", "initForm", "operate"]))
      : _createCommentVNode("", true)
  ]))
})